module.exports = __webpack_public_path__ + "static/img/iot1.2b18310d.jpg";